import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'umi';

import Drawer from '@/components/Drawer';
import { F } from '@/utils/intl';
import * as SkillSelectors from '@/selectors/skillSelectors';
import SkillsManager from './SkillsManager';

/** The skills manager in a drawer, opened from the user screens. */
const SkillsDrawer: React.FC = () => {
  const dispatch = useDispatch();
  const open = useSelector(SkillSelectors.selectSkillsDrawerOpen);
  const close = useCallback(() => dispatch({ type: 'skills/closeDrawer' }), [dispatch]);

  return (
    <Drawer
      title={<F id="entity.skill.plural" defaultMessage="Skills" />}
      open={open}
      onOpenChange={close}
      width={520}
    >
      {/* Mounted only while open: it (re)loads the list each time the drawer opens. */}
      {open && <SkillsManager />}
    </Drawer>
  );
};

export default SkillsDrawer;
